import { create } from 'zustand';
import { subscribeWithSelector } from 'zustand/middleware';

import { User } from '../types';

interface UserStore {
  user: User | null;
  accessToken: string | null;
  isLoggingIn: boolean;
  adminMode: boolean;

  setUser: (user: User | null) => void;
  setAccessToken: (accessToken: string) => void;
  saveAccessToken: () => void;
  clearAccessToken: () => void;
  setIsLoggingIn: (status: boolean) => void;
  setAdminMode: (adminMode: boolean) => void;
}

export const useUserStore = create<UserStore>()(
  subscribeWithSelector((set, get) => ({
    user: null,
    accessToken: localStorage.getItem('accessToken') || null,
    isLoggingIn: false,
    adminMode: false,

    setUser: (user) => set({ user }),
    setAccessToken: (accessToken) => set({ accessToken }),
    saveAccessToken: () => {
      const token = get().accessToken;
      if (token) localStorage.setItem('accessToken', token);
    },
    clearAccessToken: () => {
      localStorage.removeItem('accessToken');
      set({ accessToken: null });
    },
    setIsLoggingIn: (status) => set({ isLoggingIn: status }),
    setAdminMode: (adminMode) => set({ adminMode }),
  })),
);
